const NotePanel = ({ t, user, strip }) => (
  <div className={strip ? 'immob-note immob-note--strip' : 'immob-note'}>
    <div className="immob-note-main">
      <span className="immob-note-label">{t('common:pats-note-label')}</span>
      <p className="immob-note-body">{t('common:pats-note-condensed')}</p>
    </div>
    <p className="immob-note-account">
      {t('common:name')} <strong>{`${user.first_name} ${user.last_name}`}</strong><br />
      {t('common:email')} <strong>{user.username}</strong>
    </p>
  </div>
)

export default NotePanel



// WEBPACK FOOTER //
// ./components/PATSCodes/NotePanel.js